/**
 * Avatar face catalogue API — GET /api/v1/avatars/faces.
 *
 * The provider-neutral face catalogue behind `AvatarFacePicker`, served by the
 * standalone livekit-free faces router (`modules/avatars/api/faces_routes.py`).
 *
 * Hand-written rather than via the generated client because the generated op is
 * typed `unknown` (the catalogue response carries no schema-first model yet — see
 * the `typed-surface-ok` note on the route). This keeps the picker strongly typed.
 */
import { apiGet } from '../../../shared/api/axiosInstance';
import type { AvatarFace } from '../types';

export const avatarFacesApi = {
  listFaces: async (): Promise<AvatarFace[]> => {
    const result = await apiGet<{ data: AvatarFace[] }>('/api/v1/avatars/faces');
    return result.data;
  },
};
